import { createTheme } from '@mui/material/styles'
import { baseThemeOptions } from './baseTheme'
import { darkPalette } from './palette'

/**
 * Dark theme configuration.
 * Extends baseTheme with dark palette colors.
 */
export const darkTheme = createTheme({
    ...baseThemeOptions,
    palette: {
        mode: 'dark',
        ...darkPalette,
    },
})
